import { render } from "./ReconfigureGatewayForm.vue?vue&type=template&id=4050bdd6"
import script from "./ReconfigureGatewayForm.vue?vue&type=script&lang=js"
export * from "./ReconfigureGatewayForm.vue?vue&type=script&lang=js"
script.render = render

export default script